import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppBar, Box, Button, IconButton, Toolbar } from '@mui/material';
import { experimentalStyled } from '@mui/material/styles';
import type { AppBarProps } from '@mui/material';
import MenuIcon from '../../icons/Menu';
import AccountPopover from '../../components/dashboard/AccountPopover';
import ContactsPopover from '../../components/dashboard/ContactsPopover';
import ContentSearch from '../../components/dashboard/ContentSearch';
import LanguagePopover from '../../components/dashboard/LanguagePopover';
import Logo from '../../components/Logo';
import NotificationsPopover from '../../components/dashboard/NotificationsPopover';
import { getLandingPath } from '../../routesPaths';
import { Notification } from '../../types/notification';
import NavbarCheckPermissions from './NavbarCheckPermissions';

interface DashboardNavbarProps extends AppBarProps {
  onSidebarMobileOpen?: () => void;
  notificationsCount?: number;
  notifications?: Array<Notification>;
  onMarkNotificationsAsRead?: () => void;
  onMarkNotificationAsRead?: (notification: Notification) => void;
}

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    color: theme.palette.primary.contrastText,
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  }),
  zIndex: theme.zIndex.drawer + 100,
}));

const DashboardNavbar: FC<DashboardNavbarProps> = (props) => {
  const {
    onSidebarMobileOpen,
    notificationsCount,
    notifications,
    onMarkNotificationsAsRead,
    onMarkNotificationAsRead,
    ...other
  } = props;

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <IconButton
          color="inherit"
          onClick={onSidebarMobileOpen}
          sx={{
            display: 'none',
          }}
          size="large"
        >
          <MenuIcon fontSize="small" />
        </IconButton>
        <RouterLink to={getLandingPath()}>
          <Logo
            sx={{
              display: {
                lg: 'inline',
                xs: 'inline',
              },
              height: 41,
              width: 150,
              mt: 0.5,
            }}
          />
        </RouterLink>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2,
          }}
        />
        {/*<LanguagePopover />*/}
        {/*<Box sx={{ ml: 1 }}>*/}
        {/*  <ContentSearch />*/}
        {/*</Box>*/}
        {/*<Box sx={{ ml: 1 }}>*/}
        {/*  <ContactsPopover />*/}
        {/*</Box>*/}
        <Box sx={{ ml: 1 }}>
          <NavbarCheckPermissions />
        </Box>
        <Box sx={{ ml: 1 }}>
          <NotificationsPopover
            notificationsCount={notificationsCount}
            notifications={notifications}
            onMarkNotificationsAsRead={onMarkNotificationsAsRead}
            onMarkNotificationAsRead={onMarkNotificationAsRead}
          />
        </Box>
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func,
};

export default DashboardNavbar;
